'use strict';
// Helper method to toggle visibility of a component by 
// adding or removing the 'open' class based on its current state.
function ToggleComponent(componentId, disableBackgroundScroll = true) {
    var component = document.getElementById(componentId);
    if (component.classList.contains('open')) {
        component.classList.remove('open');
        if (disableBackgroundScroll) {
            window.document.body.classList.remove('scrolling-disabled');
        }
    } else {
        component.classList.add('open');
        if (disableBackgroundScroll) {
            window.document.body.classList.add('scrolling-disabled');
        }
    }
    console.log('Toggled component with ID:', componentId);
}

window.ToggleComponent = ToggleComponent;